import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { AgentComponent } from "./agent.component";
import { AgentDashboardComponent } from "./components/dashboard/agent-dashboard.component";
import { PatientComponent } from "./components/patient/patient.component";
const routes: Routes = [
  {
    path: "",
    component: AgentComponent,
    children: [
      {
        path: "",
        redirectTo: "/dashboard",
        loadComponent: () =>
          import(
            "./components/dashboard/appointment-list/appointment-list.component"
          ).then((m) => m.AppointmentListComponent),
        pathMatch: "full",
      },
      {
        path: "dashboard",
        component: AgentDashboardComponent,
        data: { animation: "AgentDashboardComponent" },
      },
      {
        path: "patient",
        component: PatientComponent,
        data: { animation: "PatientComponent" },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentRoutingModule {}
